<template>
    <div>
        <div class="collapsible-panel-title" @click.stop.prevent="togglePanel" :style="{ ...titleStyle, cursor: collapsible ? 'pointer' : 'default' }">
            <div class="collapsible-panel-title-txt" :style="textStyle">{{ title }}</div>
            <a-tooltip style="margin-top: 3px;color: red" v-if="tooltip">
                <template slot="title">
                    {{ tooltip }}
                </template>
                <a-icon type="exclamation-circle" />
            </a-tooltip>
            <div class="collapsible-panel-title-line" :style="lineStyle" />
            <div v-if="showTrigger" class="collapsible-panel-title-trigger" :style="triggerStyle">
                <a-icon :type="collapsed ? 'down' : 'up'" />
            </div>
        </div>
        <div v-show="!collapsed" style="margin:10px;" :style="contentStyle">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "FGCollapsiblePanel",
    props: {
        collapsible: {
            type: Boolean,
            default: true
        },
        defaultCollapsed: {
            type: Boolean,
            default: false
        },
        showTrigger: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ""
        },
        titleStyle: {
            type: Object,
            default: () => {}
        },
        textStyle: {
            type: Object,
            default: () => {}
        },
        triggerStyle: {
            type: Object,
            default: () => {}
        },
        contentStyle: {
            type: Object,
            default: () => {}
        },
        lineStyle: {
            type: String,
            default: () => {}
        },
        tooltip: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            collapsed: this.defaultCollapsed
        };
    },
    methods: {
        togglePanel() {
            if (!this.collapsible) {
                return;
            }
            this.collapsed = !this.collapsed;
        }
    }
};
</script>
<style lang="scss" scoped>
.collapsible-panel-title {
    width: 100%;
    height: 20px;
    margin: 24px 0 0 0;
    display: flex;

    .collapsible-panel-title-txt {
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        color: #1e202d;
        border-left: 5px solid #33cde5;
        padding: 0 8px;
    }

    .collapsible-panel-title-line {
        flex: 1;
        height: 1px;
        margin-top: 9px;
        background-color: #e4e6f2;
    }

    .collapsible-panel-title-trigger {
        margin: 0px 8px;
        font-size: 14px;
        color: #33cde5;
    }
}
</style>
